import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { LabourRatesPage } from '@/features/market/labour-rates-page';

const searchSchema = z.object({ region: z.string().optional().catch(undefined) });

export const Route = createFileRoute('/_app/marketplace/labour-rates')({
  validateSearch: searchSchema,
  component: LabourRoute,
});

function LabourRoute() {
  const { region } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <LabourRatesPage
      region={region ?? ''}
      onRegion={(next) => void navigate({ search: { region: next || undefined }, replace: true })}
    />
  );
}
